import http from '../_http'

const system = {
  //default
  summarySys: (m) => { return http.get(`manager/wsfinder/system`, m); },
  listSys: (m) => { return http.post(`manager/wsfinder/system/list`, m); },
  detailSys: (m) => { return http.get(`manager/wsfinder/system/${m.id}`); },

  //crud
  insertSys: (m) => { return http.post(`manager/wsfinder/system`, m); },
  updateSys: (m) => { return http.put(`manager/wsfinder/system`, m); },
  deleteSys: (m) => { return http.delete(`manager/wsfinder/system/${m.id}`); },
}

export default system

export { system }